{
  "version": 1,
  "asset_id": "003e9029-6008-47b1-a43a-0166664c2c31",
  "project_id": "8cc9b1c1-0457-40cd-aa82-ea9e6032ce50",
  "url": "/__l5e/assets-v1/003e9029-6008-47b1-a43a-0166664c2c31/karaoke-38.webp",
  "r2_key": "a/v1/8cc9b1c1-0457-40cd-aa82-ea9e6032ce50/003e9029-6008-47b1-a43a-0166664c2c31/karaoke-38.webp",
  "original_filename": "karaoke-38.webp",
  "size": 128904,
  "content_type": "image/webp",
  "created_at": "2026-10-12T09:41:08Z"
}
